export const getItemPriceByQuantity = (quantity, type, bundles) => {
  let itemPrice = 0,
    _bundle = null;
  if (bundles.length === 0) return 0;

   _bundle = bundles.find((bundle) => bundle.title === type);

   if (typeof _bundle === "undefined") return 0;

  function findVolumePrice(_bundle, quantity) {
    let _variantFound = null;
    if (typeof _bundle.variants === "undefined") return 0;

    _variantFound = _bundle.variants.find((variant) => quantity === parseInt(variant.option1));

    return typeof _variantFound !== "undefined" ? _variantFound.price : 0;
  }

  itemPrice = findVolumePrice(_bundle, quantity);

  if (!itemPrice) {
    itemPrice = _bundle.variants.find((variant) => _bundle.variants.length === +variant.title).price;
  }

  return parseFloat(itemPrice);
};

export const getActualMealTypeQuantity = (limitations, mealType, selectedMeals) => {
  let overallLimitAccordingToType = 0;
  let selectedMealsQuantity = 0;

  const calculteSeletedMealsOfType = (list) => {
    let quantity = 0;
    if (!list.length) return quantity;
    list.forEach((element) => (quantity += element.quantity));
    return quantity;
  };

  if (mealType.includes("Breakfasts")) {
    overallLimitAccordingToType = limitations.breakfastsMinLimit + limitations.additionalMealsMinLimit.breakfastsMinLimit;
    selectedMealsQuantity = calculteSeletedMealsOfType(selectedMeals.breakfasts);
  } else {
    overallLimitAccordingToType = limitations.entreesMinLimit + limitations.additionalMealsMinLimit.entreesMinLimit;
    selectedMealsQuantity = calculteSeletedMealsOfType(selectedMeals.entrees);
  }

  return overallLimitAccordingToType > selectedMealsQuantity ? overallLimitAccordingToType : selectedMealsQuantity;
};

export const getDietType = (mealType, dietType) => {
  switch (dietType) {
    case "Mediterranean Plan":
      return `Mediterranean ${mealType}`;
    case "Low-FODMAP Plan":
      return `Low-FODMAP ${mealType}`;
    case "Diabetes Plan":
      return `Diabetes-Friendly ${mealType}`;
    case "Gluten-Free Plan":
      return `Gluten-Free ${mealType}`;
    case "Heart-Friendly Plan":
      return `Heart-Friendly ${mealType}`;
    case "Carb-Conscious Plan":
      return `Carb-Conscious ${mealType}`;
    case "B2B Plan":
      return `B2B ${mealType}`;
    case "Care Plan":
      return `Care ${mealType}`;
    case "GLP-1 Plan":
      return `GLP-1 ${mealType}`;
    default:
      return "404";
  }
};

export const calculateAdditionalMealsQuantity = (selectedBreakfasts, selectedEntrees, limit) => {
  const additionalsBreakfastsMinLimit = limit.additionalMealsMinLimit.breakfastsMinLimit;
  const additionalsEntreesMinLimit = limit.additionalMealsMinLimit.entreesMinLimit;
  const breakfastsOverLimit = selectedBreakfasts - limit.breakfastsMinLimit > 0 ? selectedBreakfasts - limit.breakfastsMinLimit : 0;
  const entreesOverLimit = selectedEntrees - limit.entreesMinLimit > 0 ? selectedEntrees - limit.entreesMinLimit : 0;

  return {
    additionalBreakfastsQuantity: additionalsBreakfastsMinLimit > breakfastsOverLimit ? additionalsBreakfastsMinLimit : breakfastsOverLimit,
    additionalEntreesQuantity: additionalsEntreesMinLimit > entreesOverLimit ? additionalsEntreesMinLimit : entreesOverLimit,
  };
};

export const calculateMealPriceAccordingToTotals = (addQuantity, selectedQuantity, limit, type, dietType, bundles) => {
  if (addQuantity > selectedQuantity) {
    return getItemPriceByQuantity(addQuantity, getDietType(type, dietType), bundles);
  } else {
    return getItemPriceByQuantity(selectedQuantity, getDietType(type, dietType), bundles);
  }
};

export const calculateMealsQuantity = (meals) => {
  let quantity = 0;
  meals.forEach(function (meal) {
    quantity += meal.quantity;
  });

  return quantity;
};
